/**
 * SessionItem component
 *
 * Single session in the sidebar list with title, date, and delete button.
 */

import type { Session } from '../../types';

interface SessionItemProps {
  session: Session;
  isActive: boolean;
  onSelect: (uuid: string) => void;
  onDelete: (uuid: string) => void;
}

export function SessionItem({
  session,
  isActive,
  onSelect,
  onDelete,
}: SessionItemProps) {
  const handleClick = () => {
    onSelect(session.session_uuid);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (window.confirm('Da li sigurno želiš da obrišeš ovu sesiju?')) {
      onDelete(session.session_uuid);
    }
  };

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('sr-RS', {
      day: 'numeric',
      month: 'short',
    });
  };

  return (
    <div
      className={`session-item ${isActive ? 'active' : ''}`}
      onClick={handleClick}
      data-testid="session-item"
    >
      <div className="session-title">{session.title || 'Nova sesija'}</div>
      <div className="session-date">{formatDate(session.created_at)}</div>
      <button
        className="delete-btn"
        onClick={handleDelete}
        data-testid="delete-session"
        title="Obriši sesiju"
      >
        ×
      </button>
    </div>
  );
}

export default SessionItem;
